import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { transientAppCacheFeature } from './transient-app-cache.reducer';

@NgModule({
  imports: [StoreModule.forFeature(transientAppCacheFeature)],
})
export class TransientAppCacheModule {}
